import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./hooks/ProtectedRoute";


import SetupWizard from "./pages/Register/Register";
import AppLayout from "./components/layout/AppLayout";

import Dashboard from "./pages/Dashboard";
import Agents from "./pages/agent/Agents";
import Leads from "./pages/leads/Leads";
import LandingPage from "./pages/LandingPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AgentDetails from "./pages/agent/AgentDetailsPage";

import LeadActivity from "./components/leads/LeadActivity";


function App() {
  const basePath = import.meta.env.VITE_BASE_PATH;

  return (
    <BrowserRouter basename={basePath}>
      <Routes>
        {/* ✅ Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />

        {/* redirects */}
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="/login/admin" element={<Navigate to="/admin-login" replace />} />

        {/* ✅ Protected Routes */}
        <Route element={<ProtectedRoute />}>
          
          {/* Layout wrapper ONCE */}
          <Route
            element={<AppLayout />}
          >
            <Route path="/dashboard" element={<Dashboard/>} />

            <Route
              path="/agents"
              element={<Agents />}
            />

            <Route
              path="/profile/:id"
              element={<AgentDetails />}
            />

            <Route
              path="/agents/:id"
              element={<AgentDetails />}
            />

            <Route
              path="/leads"
              element={<Leads />}
            />

            <Route
              path="/leads/activity"
              element={<LeadActivity />}
            />

            <Route
              path="/register"
              element={<SetupWizard />}
            />
          </Route>

        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
